// extracted by mini-css-extract-plugin
export var legendIndicator = "_gl-1";
export var legendRight = "_gl-0";